// eslint-disable-next-line import/prefer-default-export
export const EXTERNAL_URL_PREFIX = 'http';
export const HERO_PROMO_TEMPLATE = 'HeroPromo';
export const HERO_PROMO_TEXT_TEMPLATE = 'HeroPromoText';
export const HERO_PROMO_IMAGE_TEMPLATE = 'HeroPromoImage';
export const RIBBON_PROMO_TEMPLATE = 'RibbonPromo';
export const HERO_INTRO_PROMO_TEMPLATE = 'HeroIntroPromo';
export const CAROUSEL_SPEED = 5000;
export const ADMIN_LINK_PREFIX = 'admin.insomniacookies.com/';
export const CDN_LINK_PREFIX = 'cdn1.insomniacookies.com/';